import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom';
import greenLogo from '../../assets/images/greenLogo.png'

function Footer() {

    return (
        <>
            <section className="footer-section" id="contact">
                <div className="container">
                    <div className="row">

                        <div className="col-md-4 col-sm-6 footer-col">
                            <div className='firstPfooter'>
                                <img src={greenLogo} alt="greenLogo" />
                                <p>
                                    هندسة تُرى , جودة تُلمس
                                </p>
                            </div>
                            <div className="social-links">
                                <a href="https://www.facebook.com/share/1BVLXisAxv" target="_blank" rel="noopener noreferrer">
                                    <i className="bi bi-facebook"></i>
                                </a>

                                <a href="https://www.instagram.com/seen7.company?igsh=MTV0MHNvMzFob2Vocg==" target="_blank" rel="noopener noreferrer">
                                    <i className="bi bi-instagram"></i>
                                </a>

                                <a href="https://wa.me/963957362344" target="_blank" rel="noopener noreferrer">
                                    <i className="bi bi-whatsapp"></i>
                                </a>

                                <a href="mailto:Seen7.company@gmail.com" target="_blank" rel="noopener noreferrer">
                                    <i className="bi bi-envelope-fill"></i>
                                </a>
                            </div>
                        </div>


                        <div className="col-md-3 col-sm-6 footer-col">
                            <h4>البريد الالكتروني والهاتف</h4>
                            <ul>
                                <li>
                                    <i className="bi bi-envelope"></i>
                                    <a href="mailto:Seen7.company@gmail.com" target="_blank" rel="noopener noreferrer">
                                        Seen7.company@gmail.com
                                    </a>
                                </li>
                                <li>
                                    <i className="bi bi-telephone"></i>
                                    <a href="https://wa.me/963957362344" target="_blank" rel="noopener noreferrer">
                                        963-957362344+
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="col-md-3 col-sm-6 footer-col">
                            <h4>خدماتنا</h4>
                            <ul>
                                <li>- التصميم الهندسي المعماري</li>
                                <li>- استشارات هندسية</li>
                                <li>- التصميم والتنسيق الداخلي</li>
                                <li>- التحليل الإنشائي </li>
                            </ul>
                        </div>

                        <div className="col-md-2 col-sm-6 footer-col">
                            <h4>روابط سريعة</h4>
                            <ul>
                                <li><Link to='/about'>- عن الشركة</Link></li>
                                <li><Link to='/whyUs'>- لماذا نحن</Link></li>
                                <li><Link to='/services'>- خدماتنا</Link></li>
                                <li><Link to='/contact'>- تواصل معنا</Link></li>
                            </ul>
                        </div>

                    </div>

                    <div className="row d-flex justify-content-center align-items-center last-footer">
                        <div className="col-md-6 col-sm-12 text-center copyright">
                            Copyright © 2025
                            <span>
                                <a href="https://wa.me/963957362344" target="_blank" rel="noopener noreferrer">
                                    Seen Company
                                </a>
                            </span>
                        </div>
                        <div className="col-md-6 col-sm-12 text-center design">
                            Website Created By
                            <span>
                                <a href="https://wa.me/963946454672" target="_blank" rel="noopener noreferrer">
                                    Mahmoud Agha
                                </a>
                            </span>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Footer
